import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Behöver jag göra om provet om jag utökar tillståndet?";
const SHORT_ANSWER = "Om utökningen är till en mer omfattande tillståndstyp (t.ex. från slutet sällskap till allmänheten) krävs det större provet. Annars normalt inte.";

export const Route = createFileRoute("/fraga/behover-jag-gora-om-provet-vid-utokning")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Behöver jag göra om provet om jag utökar tillst…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Tillfälligt → stadigvarande, slutet → allmänheten = nytt och större prov. Övriga ändringar (lokal, öppettider) kräver inte nytt prov."}
      source={{ label: "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", href: "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsprov-alkohollagen", label: "Kunskapsprovet – när krävs nytt prov" }}
      related={[{"to": "/fraga/hur-bra-ar-folkhalsomyndighetens-databas", "label": "Hur ser kunskapsprovets frågedatabas ut?"}, {"to": "/fraga/far-jag-rast-under-provet", "label": "Får jag ta rast under kunskapsprovet?"}, {"to": "/fraga/hur-lange-galler-godkant-prov", "label": "Hur länge gäller ett godkänt kunskapsprov?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Behöver jag göra om provet om jag utökar tillståndet?" },
      { name: "description", content: "Om utökningen är till en mer omfattande tillståndstyp (t.ex. från slutet sällskap till allmänheten) krävs det större provet. Annars normalt inte." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/behover-jag-gora-om-provet-vid-utokning" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/behover-jag-gora-om-provet-vid-utokning" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/behover-jag-gora-om-provet-vid-utokning",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Behöver jag göra om provet om jag utökar tillst…", url: "https://alkoholprovet.se/fraga/behover-jag-gora-om-provet-vid-utokning" },
      ]),
    ],
  }),
});
